/* eslint-disable @typescript-eslint/require-await */
import { Promise } from 'bluebird';
import { TaskQueue } from 'cwait';

/**
 * Like Promise.all, but limits the number of concurrent promises
 * @param array Input array
 * @param callback Callback that maps each element in `array` to a Promise
 * @param queueSize Size of the task queue. Defaults to 15.
 * @returns A Promise that resolves to an array of the resolved type of `callback`
 */
export async function queuePromises<T, U>(
  array: T[],
  callback: (value: T) => Promise<U>,
  queueSize = 15
): Promise<U[]> {
  const queue = new TaskQueue(Promise, queueSize);
  return Promise.map(array, queue.wrap(callback));
}
